import { render, staticRenderFns } from "./ChatNavbar.vue?vue&type=template&id=0ad27536&scoped=true"
import script from "./ChatNavbar.vue?vue&type=script&lang=js"
export * from "./ChatNavbar.vue?vue&type=script&lang=js"
import style0 from "./ChatNavbar.vue?vue&type=style&index=0&id=0ad27536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad27536",
  null
  
)

export default component.exports